const vacationStatuses = {
    active: 'active',
    pending: 'pending',
    historic: 'historic'
};

export { vacationStatuses };
